module.exports = __webpack_public_path__ + "img/1-6373.d250835f.png";